import VueGtag from 'vue-gtag-next';

// GA4設定
export default {
  install(app, router) {
    app.use(VueGtag, {
      property: {
        id: 'G-FG7PHMJ38E', // GA4測定ID
        params: {
          send_page_view: false // 手動でページビューを制御
        }
      },
      useDebugger: process.env.NODE_ENV !== 'production', // 開発環境でデバッグ
      bootstrap: true
    }, router);
  }
};